import React from "react";
import { Layout, Typography, Image } from "antd";
import CommonSidebar from "../../components/CommonSidebar";
import problemImage from "../../assets/focus.jpg";

const { Title, Paragraph } = Typography;
const { Content } = Layout;

const ProblemsWeAreSolvingPage = () => {
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Layout style={{ background: "#fff" ,}}>
        {/* Sidebar */}
        <CommonSidebar defaultSelectedKey="2" />

        {/* Main Content */}
        <Layout
          style={{
            background: "#fff",
            display: "flex",
            justifyContent: "start",
            alignItems: "start",
            padding: "20px 20px",
            flex: 1, 
          }}
        >
          <Content
            style={{
              width: "100%",
              maxWidth: "100%", 
            }}
          >
            {/* Image Section */}
            <div style={{ textAlign: "left", marginBottom: "30px" }}>
              <Image
                src={problemImage}
                alt="Problems We Are Solving"
                style={{
                  width: "100%",
                  borderRadius: "10px",
                }}
                preview={false}
              />
            </div>

            {/* Text Section */}
            <Typography>
            

              <Paragraph style={{ fontSize: "16px", color: "#444" }}>
                At <strong>Yalla Nellab</strong>, we believe sport has the power
                to heal, connect and transform lives. Yet today, many barriers
                prevent people — especially the youth — from living active,
                healthy lifestyles. Our mission is to change that.
              </Paragraph>

              <Paragraph style={{ fontSize: "16px", color: "#444" }}>
                <strong>1. Rising Childhood Obesity</strong> <br />
                Kids are moving less and spending more time on screens.
                Physical activity is being replaced by digital distractions,
                leading to serious long-term health risks.
              </Paragraph>

              <Paragraph style={{ fontSize: "16px", color: "#444" }}>
                <strong>2. Lifestyle Diseases</strong> <br />
                Early signs of diabetes, hypertension and heart issues are now
                common across all ages. Regular sport and movement can play a
                vital role in prevention and wellness.
              </Paragraph>

              <Paragraph style={{ fontSize: "16px", color: "#444" }}>
                <strong>3. Mental Health Decline</strong> <br />
                The lack of play, teamwork and social interaction has
                contributed to rising anxiety, stress and depression —
                especially among youth.
              </Paragraph>

              <Paragraph style={{ fontSize: "16px", color: "#444" }}>
                <strong>4. Talent Lost Too Soon</strong> <br />
                Many passionate young athletes never get the platform, access
                or support to develop their skills and fulfill their potential.
              </Paragraph>

              <Paragraph style={{ fontSize: "16px", color: "#444" }}>
                <strong>5. Disconnected Communities</strong> <br />
                Sport once united neighborhoods and created bonds that went
                beyond the game. Today, those shared moments are disappearing —
                and with them, a sense of belonging.
              </Paragraph>
            </Typography>
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default ProblemsWeAreSolvingPage;